const AUTH_TOKEN = "authToken";

const MAX_FONT_SIZE = 60

const MIN_FONT_SIZE = 9

export { AUTH_TOKEN, MAX_FONT_SIZE, MIN_FONT_SIZE };

export const ELEMENT_KIND = {
    TEXT: 1,
    SIGNATURE: 2,
    DATE: 3,
    INITIALS: 4,
    CHECKBOX: 5,
    RADIO: 6,
    AADHAAR: 7,
    PAYMENT: 8,
    DROP_DOWN: 9,
    SIGN_STAMP: 10,
}